import authPartner from '../../fields/other/authPartner';

export const QUERY_GET_ALL_AUTH_PARTNERS = /* GraphQL */ `
	query ($filter: AuthPartnerFilter, $limit: Float, $notEqual: AuthPartnerFilter, $offset: Float = 0){
		getAllAuthPartners (
            filter: $filter
            limit: $limit
            notEqual: $notEqual
            offset: $offset
        ) {
            items{
                ${authPartner}
            }
            total
        }
	}
`;
